import { useQueryParams, useDataLayer } from '~hooks'
import { Dropdown } from '~shared'
import { DateRangeFilterValues } from 'constants/event-filters'

const OPTIONS = [
  {
    label: 'All Dates',
    value: DateRangeFilterValues.all,
  },
  {
    label: 'Today',
    value: DateRangeFilterValues.today,
  },
  {
    label: 'This Weekend',
    value: DateRangeFilterValues.weekend,
  },
  {
    label: 'This Month',
    value: DateRangeFilterValues.month,
  },
]

const EventsDateRangeFilter = () => {
  const { replace, query } = useQueryParams()
  const { push } = useDataLayer()

  const onSelect = (v: string) => {
    replace(
      {
        query: {
          ...query,
          dateRange: v,
        },
      },
      null,
      { shallow: true }
    )

    push({
      event: 'date_range_filter_interaction',
      method: v,
    })
  }

  return (
    <Dropdown
      options={OPTIONS}
      onSelect={onSelect}
      placeholder="FILTER BY DATE"
      value={query.dateRange}
    />
  )
}

export default EventsDateRangeFilter
